import PermissionState from "./permission.types";

export const state: PermissionState = {
  policies: [],
  loading: false
};

export default state;
